/**
 * Fixture for the schedule-editor widget — shape of draft_schedule's
 * structured output (mcp/server.ts draftScheduleTool): a no-side-effect
 * draft (the 01:30 nightly sweep), the agent dropdown options, isEdit.
 * Phase-9 fields (model/effort/alwaysRun) ride the draft so the new
 * selects + always-run toggle render their defaults.
 */
import { AGENT_NAMES } from "./seed";

export function scheduleEditorFixture(): Record<string, unknown> {
  return {
    draft: {
      name: "Nightly inbox sweep",
      cron: "30 1 * * ? *",
      timezone: "America/New_York",
      agentName: "email-triage",
      prompt:
        "Sweep the overnight inbox. Flag anything urgent, draft replies " +
        "for review, and file the rest.",
      mode: "message",
      loopInterval: null,
      enabled: true,
      model: null,
      effort: null,
      alwaysRun: false,
    },
    agents: [...AGENT_NAMES],
    isEdit: false,
    teamRef: null,
  };
}
